module.exports = __webpack_public_path__ + "static/media/source.da08a4c6.svg";